import { request } from '@/shared/api/request'

export const getEmployerSignedXml = (externalId) => {
	return request({ url: `colcontract/ecd/employer/xml/${externalId}`, method: 'GET' })
}
